export default host => (clients) =>
  `${host}/users/export?${clients ? `&clients=${clients.map(client => client.value)}` : '' }`

